// Skeleton — shimmer placeholder for loading states (Frontend Rules §12: every
// data component shows a loading skeleton). Variants cover the common shapes.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './skeleton.css';

export function Skeleton({ variant = 'text', width, height, count = 1, className }) {
  const items = Array.from({ length: count });
  return (
    <>
      {items.map((_, i) => (
        <span
          key={i}
          className={cx('skeleton', `skeleton--${variant}`, className)}
          style={{ width, height }}
          aria-hidden="true"
        />
      ))}
    </>
  );
}

Skeleton.propTypes = {
  variant: PropTypes.oneOf(['text', 'title', 'circle', 'card', 'block']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Render N stacked lines (useful for text blocks). */
  count: PropTypes.number,
  className: PropTypes.string,
};

export default Skeleton;
